import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'

const NeInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postneonline } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()
    const intialValues = {
        filingstatus: "",
        totalnoofallowances: "",
        additionalamount: "",
        exemptionindicator: ""


    }

    const w4schema = () => {
        const baseSchema = {
            filingstatus: yup.string().required('Filing status is a required field'),
            totalnoofallowances: yup.string().required('Total no of allowances is a required field'),
            additionalamount: yup.string().nullable(),
            exemptionindicator: yup.string()
                .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
                .nullable()

        }
        return yup.object(baseSchema)
    }
    const schema = w4schema()
    const options1 = [
        {
            key: 1,
            value: 'Single'
        },
        { key: 2, value: 'Married Filing Jointly or Qualifying Widow' },

    ]
    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'NE Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {
                        const data = {
                            entityId: personalstore?.personalData?.entityId,
                            essUserKey:
                                initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey:
                                essUserOnBoardingFormKey,
                            completeOnline: mode === 'upload' ? false : true,
                            filingStatus: values?.filingstatus,
                            totalNoOfAllowances: values?.totalnoofallowances,
                            additionalAmount: values?.additionalamount ? values?.additionalamount : null,
                            exemptionIndicator: values?.exemptionindicator
                        }


                        const response = await postneonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('NeInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }

                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }

                    }}
                >
                    {(props) => (
                        <View>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '65%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Filing status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Filing status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.filingstatus
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('filingstatus', option)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.filingstatus &&
                                            props.errors.filingstatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.filingstatus}
                                                </Text>
                                            )}
                                    </View>
                                </View>



                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Total no of allowances you are claiming *'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.totalnoofallowances}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('totalnoofallowances')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.totalnoofallowances &&
                                            props.errors.totalnoofallowances && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.totalnoofallowances as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                {props.values.exemptionindicator?.toLowerCase() !== 'exempt' && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '65%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'Enter the amount you want to withhold from each check for Nebraska income tax'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '30%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.additionalamount}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('additionalamount')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.additionalamount &&
                                                props.errors.additionalamount && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.additionalamount as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                )}


                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                `Do you qualify to claim exemption from Nebraska income tax withholding? If yes, type “Exempt”'`
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.exemptionindicator}
                                            onChangeText={(text) => {
                                                props.handleChange('exemptionindicator')(text)
                                                if (text?.toLowerCase() === 'exempt') {
                                                    props.setFieldValue('additionalamount', '')
                                                }
                                            }}
                                        />
                                        {props.touched.exemptionindicator &&
                                            props.errors.exemptionindicator && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.exemptionindicator}
                                                </Text>
                                            )}
                                    </View>
                                </View>





                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </View>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default NeInformationForm
